const parallaxStyle = {
  parallax: {
    minHeight: "620px",
    height: "88vh",
    maxHeight: "820px",
    overflow: "hidden",
    position: "relative",
    backgroundPosition: "center center",
    backgroundSize: "cover",
    margin: "0",
    padding: "0",
    border: "0",
    display: "flex",
    alignItems: "center",
    "@media (max-width: 700px)": {
      minHeight: "660px",
      height: "auto",
      paddingTop: "88px",
      paddingBottom: "54px"
    }
  },
  filter: {
    "&:before": {
      background: "linear-gradient(115deg, rgba(7, 34, 26, 0.9) 0%, rgba(20, 89, 67, 0.78) 42%, rgba(12, 27, 45, 0.56) 100%)"
    },
    "&:after,&:before": {
      position: "absolute",
      zIndex: "1",
      width: "100%",
      height: "100%",
      display: "block",
      left: "0",
      top: "0",
      content: "''"
    }
  },
  small: {
    height: "380px"
  }
};

export default parallaxStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/components/parallaxStyle.jsx